'use client';

import { FC } from 'react';

import { GameCategories } from './Categories';
import { Providers, ProvidersProps } from './Providers';
import { Search } from './Search';
import { Topics } from './Topics';
import { useCommonStore } from '@/store';

import {
  ScFilterGames,
  ScFilterGamesContainer,
  ScFilterGamesMob,
  ScGamesSectionPoint,
  ScSearchGroup,
} from './styled';
import { ScContainer } from '@/styles/common';

export type FilterGamesProps = ProvidersProps & GameCategoriesProps;

export interface GameCategoriesProps {
  categoryId?: string;
  subCategoryId?: string;
}

export const FilterGames: FC<FilterGamesProps> = (props) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <>
      <ScGamesSectionPoint id="gamesSection" />
      {isMobileDevice ? (
        <FilterGamesMobile {...props} />
      ) : (
        <FilterGamesDesktop {...props} />
      )}
    </>
  );
};

const FilterGamesDesktop: FC<FilterGamesProps> = ({
  providerId,
  categoryId,
  subCategoryId,
}) => {
  return (
    <ScFilterGamesContainer>
      <ScContainer>
        <ScFilterGames>
          <GameCategories subCategoryId={subCategoryId} />
          <ScSearchGroup>
            <Search />
            <Providers providerId={providerId} />
            <Topics categoryId={categoryId} />
          </ScSearchGroup>
        </ScFilterGames>
      </ScContainer>
    </ScFilterGamesContainer>
  );
};

const FilterGamesMobile: FC<FilterGamesProps> = ({
  categoryId,
  providerId,
  ...props
}) => {
  return (
    <ScContainer>
      <ScFilterGamesMob>
        <ScSearchGroup>
          <Search />
          <Providers providerId={providerId} />
          <Topics categoryId={categoryId} />
        </ScSearchGroup>
        <GameCategories {...props} />
      </ScFilterGamesMob>
    </ScContainer>
  );
};
